import { useState } from "react";
import { ddStyles } from "../utils/CommonStyles.js";
import Select from 'react-select';

let attributeOptions = [{label:"IDirt Analytics Flag", value:"IDirt-ANALYTICS"}];
function UserProvisioningTableRow({ key, userProvisionings, handleSubmit, setError, t, setAdd, oddIdx }) {
	const [isSubmit, setIsSubmit] = useState(false);
	const [isFlag, setIsFlag] = useState(true);
	const [attributeSelected, setAttributeSelected] = useState({ name: "attribute", label: "", value: "" });

	const flagHandler = (e) => {
		setIsFlag(e.target.checked);
	}
	const attributeHandler = (selectedOption) => {
		let attributeValue = selectedOption ? selectedOption.value : "";
		let attributeName = selectedOption ? selectedOption.label : "";
		setAttributeSelected({ ...attributeSelected, label: (attributeName), value: attributeValue });
	}
	function submitComplete() {
		setIsSubmit(false);
	}
	function submitRow() {
		setError("");
		setIsSubmit(true);
		let errors = validateFields();
		if(errors.length > 0){
			let errorText = "";
			setIsSubmit(false);
			for(let i=0; i < errors.length; i++){
				if(i > 0){
					errorText += "<br />";
				}
				errorText += errors[i];
			}
			setError(errorText);
			setIsSubmit(false);
		} else {
			let initialValues = {
				provisionedAttribute: attributeSelected.value,
				flagValue: isFlag ? 1 : 0
			};
			handleSubmit(1, initialValues, submitComplete);
		}
	}
	function submitCancel() {
		setError("");
		setAdd(false);
	}
	const validateFields = () => {
		const errors = [];
		if (!attributeSelected.value || attributeSelected.value === "") {
			errors.push(t("error.attributeReqd"));
		}
		
		if (userProvisionings && userProvisionings.length > 0) {
			userProvisionings.map((userProvisionedItem, index) => {
				if(userProvisionedItem.provisionedItem == attributeSelected.value){
					errors.push(t("error.duplicate.attribute"));
					return false;
				}
			});
		}
		return errors;
	};
	return (
		<tr key={key}>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<Select
					name="provisionedAttribute"
					options={attributeOptions}
					onChange={attributeHandler}
					placeholder={""}
					value={attributeSelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="attribute-input"
					styles={ddStyles}
				/>
			</td>
			<td className="list-td col text-center even">
				<input
					type="checkbox"
					name="flagValue"
					onChange={flagHandler}
					className="mycheckbox"
					styles={ddStyles}
					defaultChecked={true}
				/>
			</td>
			<td className="list-td col even">
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button></td>
		</tr>
	)

}
export default UserProvisioningTableRow;